import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContactForm from "./components/ContactForm";

const container = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

const values = [
  {
    icon: "ri-flashlight-line",
    title: "及时",
    desc: "第一时间聚合院线新片、热播剧集的动态与看点，让资讯不再滞后。",
  },
  {
    icon: "ri-shield-star-line",
    title: "可信",
    desc: "坚持内容甄选与信息核对，用专业影评帮助用户理性选择。",
  },
  {
    icon: "ri-heart-3-line",
    title: "用心",
    desc: "从片单策划到推荐理由，每一个细节都为真正的影迷而做。",
  },
];

const services = [
  { icon: "ri-newspaper-line", title: "影视资讯", desc: "追踪行业动态与作品上新，掌握第一手影视新闻。" },
  { icon: "ri-bookmark-3-line", title: "片单推荐", desc: "编辑精选主题片单，按类型、地区、评分多维推荐。" },
  { icon: "ri-chat-quote-line", title: "影评解析", desc: "深度影评与幕后解析，带你读懂作品背后的表达。" },
  { icon: "ri-search-eye-line", title: "智能检索", desc: "关键词模糊搜索与多维筛选，快速定位想看的内容。" },
];

export default function About() {
  const [copied, setCopied] = useState(false);
  const email = "contact@honghu-film.com";

  useEffect(() => {
    document.title = "关于红狐影视 - 影视内容平台介绍与联系方式";
  }, []);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="w-full">
      <section className="relative w-full overflow-hidden bg-secondary-950">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20cinematic%20wide%20scene%20of%20rows%20of%20empty%20movie%20theater%20seats%20glowing%20under%20deep%20orange%20ambient%20light%2C%20artistic%20minimal%20mood%2C%20no%20text&width=1920&height=720&seq=hh-about-hero&orientation=landscape"
          alt="红狐影视 - 关于我们"
          className="absolute inset-0 h-full w-full object-cover object-center opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950 via-secondary-950/85 to-secondary-950/55"></div>
        <div className="relative mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6 md:py-24">
          <nav className="flex items-center gap-1.5 text-sm text-secondary-300">
            <Link to="/" className="hover:text-primary-400">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-50">关于我们</span>
          </nav>
          <h1 className="mt-5 font-heading text-3xl font-extrabold text-background-50 md:text-5xl">
            关于红狐影视
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-secondary-100 md:text-base">
            一个为影视爱好者而生的内容平台，专注聚合最新电影与电视剧资讯、专业推荐与深度影评，帮助你高效发现值得观看的作品。
          </p>
        </div>
      </section>

      <section className={`${container} py-12 md:py-16`}>
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">
              我们是谁
            </h2>
            <div className="mt-4 space-y-4 text-[15px] leading-loose text-foreground-700">
              <p>
                红狐影视诞生于一群资深影迷对“看片难、选片更难”的共同困扰。在内容爆炸的时代，观众面对海量作品常常无从下手——评分真假难辨、推荐理由含糊、资讯零散滞后。我们希望用一块干净、专业、可读性强的内容阵地，把优质的影视信息重新整理好，交到真正需要它的人手中。
              </p>
              <p>
                平台覆盖电影、电视剧两大主线，并细分为科幻、悬疑、剧情、奇幻等多种类型。无论你是想追逐院线新片、补完口碑剧集，还是想读一篇讲透作品的深度影评，红狐影视都希望成为你打开影视世界时，第一站选择的地方。我们不做播放，不做下载，只把“了解一部作品”这件事做到足够好。
              </p>
              <p>
                未来，红狐影视会持续优化推荐逻辑与内容广度，让每一位影迷都能更快、更准地遇见属于自己的那部好作品。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="rounded-lg border border-background-200/70 bg-background-100 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className={`${v.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                    {v.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    {v.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">
              服务内容
            </h2>
            <p className="mt-3 text-sm text-foreground-600">
              围绕“发现好作品”这一核心目标，我们提供以下内容服务。
            </p>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {services.map((s) => (
                <div
                  key={s.title}
                  className="flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${s.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {s.title}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded-lg border border-background-200/70 bg-background-100 p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                联系方式
              </h3>
              <div className="mt-4 space-y-3 text-sm">
                <button
                  type="button"
                  onClick={copyEmail}
                  className="flex w-full items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-left transition-colors hover:border-primary-300 cursor-pointer"
                >
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                  <span className="min-w-0 flex-1">
                    <span className="block text-xs text-foreground-500">邮箱</span>
                    <span className="block font-medium text-foreground-900">
                      {email}
                    </span>
                  </span>
                  <span className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600">
                    <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
                    {copied ? "已复制" : "复制"}
                  </span>
                </button>
                <div className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                  <i className="ri-wechat-line text-lg text-primary-500"></i>
                  <span className="min-w-0 flex-1">
                    <span className="block text-xs text-foreground-500">微信公众号</span>
                    <span className="block font-medium text-foreground-900">
                      红狐影视 RedFoxFilm
                    </span>
                  </span>
                </div>
                <div className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3">
                  <i className="ri-time-line text-lg text-primary-500"></i>
                  <span className="min-w-0 flex-1">
                    <span className="block text-xs text-foreground-500">内容更新</span>
                    <span className="block font-medium text-foreground-900">
                      每日 10:00 / 20:00
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className={`${container} pb-12 md:pb-16`}>
        <ContactForm />
      </section>

      <section className={`${container} pb-16`}>
        <div className="rounded-lg border border-background-200/70 bg-background-100 p-6 md:p-8">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
            <i className="ri-copyright-line text-primary-500"></i>
            版权声明
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本网站所有影视作品信息、海报与简介均为演示用途的虚构示例数据，仅用于产品功能展示，不构成任何真实作品介绍或商业推荐。网站内容版权归红狐影视所有，未经许可不得用于商业用途。如涉及第三方权益，请通过上方邮箱与我们联系，我们将及时处理。
          </p>
          <p className="mt-3 text-sm text-foreground-500">
            © 2026 红狐影视 RED FOX FILM. 保留所有权利。
          </p>
        </div>
      </section>
    </div>
  );
}